
export enum RequestAPI {
    LOGIN = "/public/users/login/register", //登录或注册
    SEND_CODE = "/public/users/send/code", //发送验证码
    GET_USERINFO = "/contest2024/user/get/info", //获取用户信息
    UPDATE_USER_INFO = "/contest2024/user/update/base/info", //修改个人信息
    GET_CLASS_ARRAY = "/learningCenter/course/front/list", //获取课程列表
    GET_COURSE_DETAIL_LIST = "/learningCenter/course/detail/get", //获取课程章节列表
    GET_PLAY_SIGN = "/learningCenter/course/player/sign", //获取播放器签名
    GET_WORK_LIST = "/learningCenter/work/list", //获取作品列表
    VIDEO_UPLOAD = "/learningCenter/course/upload", //作品视频上传
    IMAGE_UPLOAD = "/public/stream/upload", // 图片上传
    PROJECT_UPLOAD = "/learningCenter/work/upload",//作品信息上传
    GET_WORK_DETAIL = "/learningCenter/work/detail", //获取作品详情
    GET_RESOURCE_LIST = "/learningCenter/resource/list", //获取下载资源列表
    UPDATE_USER_PASSWORD = "/public/users/user/pwd", // 初始化后修改密码
    GET_USER_PERSONAL_INFO = "/public/users/user/info", // 获取用户个人信息
    GET_LEARNING_HISTORY_LIST = "/learningCenter/course/user/history", // 获取学习记录列表
    UPLOAD_LEARNING_TIME = "/learningCenter/course/user/history/watch", // 上传学习时长
    GET_RECENT_VIEW_TIME = "/learningCenter/course/user/history/watch/7/days", // 获取最近七日学习时长
    GET_ARTICLE_LIST = '/supplier/article/list',//获取文章列表
    GET_ARTICLE_DETAIL = '/supplier/article/detail', // 获取文章详情
    UPDATE_ARTICLE_HISTORY = '/supplier/article/history/user',// 文章浏览记录添加
    GET_UPLOAD_PROJECT_LIST = '/learningCenter/work/list/user', // 获取用户上传的作品
    GET_FILE_UPLOAD_SIGN = '/pc/tencent/upload/sign', //获取作品上传签名
    GET_CHAT_BY_STREAM = '/ai/chat/stream', //获取聊天流
    GET_CHAT_BY_USUAL = '/ai/chat', //获取聊天
    POST_TEAM_INFO = '/learningCenter/showcase/create', // 创建团队
    POST_WORK_INFO = '/learningCenter/showcase/workInfo', // 提交作品信息
    POST_WORK_FILE = '/learningCenter/showcase/workFile', // 提交作品文件
    GET_SHOWCASE_LIST_BY_USER = '/learningCenter/showcase/user/list', // 获取用户作品列表
    GET_SHOWCASE_DETAIL = '/learningCenter/showcase/workDetail', // 获取作品详情
    GET_ALI_OSS_TOKEN = '/public/oss/token/new', // 获取阿里云OSS上传token
    GET_SHOWCASE_LIST_BY_JUDGE = '/learningCenter/showcase/judge/list', // 根据评委获取作品列表
    POST_SHOWCASE_JUDGE = '/learningCenter/showcase/judge/score', // 提交评委评价
    GET_SHOWCASE_SCORE = '/learningCenter/showcase/judge/score/get', // 获取作品评分
    GET_SHOWCASE_COMMENT = '/learningCenter/showcase/judge/suggestion/get', // 获取作品评论
    POST_ADD_ATTEND = '/learningCenter/attend/add', // 新增授课签到
    GET_ATTEND_LIST = '/learningCenter/attend/user/list' // 获取用户的授课签到记录
}

// 白名单
export const WHITELIST: string[] = [
    RequestAPI.GET_CLASS_ARRAY,
    RequestAPI.GET_WORK_LIST,
    RequestAPI.LOGIN,
    RequestAPI.SEND_CODE
]
